(
    function (skyward, $, undefined)
    {
        skyward.timetrackingchangestatus = skyward.timetrackingchangestatus || {};
        var dialog;
        var init = function (selector)
        {
            $(selector).on('click', '.js-timeTrackingChangeStatus', function (_event)
            {
                var element = $(this);
                skyward.timetrackingchangestatus.changestatus(element, selector);
            });

            $(selector).on('click', '.js-changeStatusTimeTransactionDate', function (_event)
            {
                var element = $(this);
                updateTimeTransactionDate(selector, element);
            });

            $(selector).find('#TimeTransactionDate').on('change', function (_event)
            {
                reloadPage(selector);
            });

            $(selector).on('click', '.button.changeStatusEditTimeTransaction', function (event)
            {
                show(event, selector);
            });

            $(selector).on('click', '.button.changeStatusAddTimeTransaction', function (_event) {
                appendTimeTransactionRow(selector);
            });
        };

        var createJobsPopup = function(data)
        {
            var popup = function ()
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "TimeTracking/Employee/SelectJobs" + '?renderType=contentOnly',
                    data: data,
                    type: 'POST',
                    dataType: 'HTML'
                });
            };

            return popup;
        };

        var selectjob = function()
        {
            var element = $(this);
            
            skyward.buttonManager.setClass(".button");
            var data = element.data();
            var assignmentpaytypeid = element.data("selectedassignmentpaytypeid");
            data._controlAjaxFiredFrom = $("#SelectJobsStatusCode").val();
            setStatus(assignmentpaytypeid, data, element, "#lblErrorMessageChangeJobs");
        }

        skyward.timetrackingchangestatus.changestatus = function (element, selector)
        {
            if (skyward.buttonManager.isElementDisabled(element))
            {
                return;
            }

            skyward.ajax.getAllInputElements(selector).then(data =>
            {
                data._controlAjaxFiredFrom = element.data("changestatusbuttonname");

                if (element.data("changestatusbuttonwillselectjob"))
                {
                    data.SelectJobsStatusCode = element.data('changestatusbuttonselectjobscode');
                    var showJobs = createJobsPopup(data);
                    dialog = skyward.modalLayer.showDialog("Select Job", showJobs, [{ text: "Close", icon: "Close" }],
                        {
                            allowNoButtons: true,
                            draggable: true,
                            id: "TimeTransactionsSelectJobPopupModal",
                            dynamicDialogContentSelector: '#ChangeStatusSelectJobs'
                        });

                }
                else
                {
                    var assignmentPayTypeID = element.data("assignmentpaytypeid") != undefined ? element.data("assignmentpaytypeid") : $("#AssignmentPayTypeID").val();
                    setStatus(assignmentPayTypeID, data, selector);
                }
            });
        };

        var setStatus = function (assignmentPayTypeID, data, selector, errorLabelLocationOverride) {
            var container = $("#changeTimeTrackingStatusQuickEntry");
            data.EmployeeID = $("#EmployeeID").val();
            data.AssignmentPayTypeID = assignmentPayTypeID;
            data.preSaveWarningHash = container.data('preSaveWarningHash') || "";

            var labelLocation = errorLabelLocationOverride || "#lblErrorMessage";
            var promise = $.ajax(
            {
                url: skyward.global.virtualDir + "TimeTracking/Employee/UpdateStatus",
                type: "POST",
                dataType: "JSON",
                data: data
            });
            
           
            promise.done(function (data)
            {                
                if (!data.success)
                {
                    data.preSaveWarningHash = data.preSaveWarningHash;
                    skyward.validation.displayValidationMessages(data, container, $(labelLocation));
                    skyward.buttonManager.setClass(".button", false);
                }
                else
                {
                    reloadPage(selector);
                }
            });
        }

        var updateTimeTransactionDate = function (selector, element)
        {
            if (skyward.buttonManager.isElementDisabled(element))
            {
                return;
            }
            skyward.buttonManager.setClass(".toolbarControls__button--wrapText.changeStatusTimeTransactionDate");
            var data = {};
            data._controlAjaxFiredFrom = element.data("changestatusbuttonname");
            data._controlAjaxFiredFrom == 'PreviousDay' ? updateDate(selector, -1) : updateDate(selector, 1);
        };

        var updateDate = function (selector, increment)
        {
            var timeTransactionDate = $("#TimeTransactionDate");
            var date = skyward.controls.getValue(timeTransactionDate);
            date.setDate(date.getDate() + increment);
            skyward.controls.setValue(timeTransactionDate, date);
            reloadPage(selector);
        };

        function reloadPage(selector)
        {
            const timeTransactionDate = selector != null ? skyward.controls.getValue($(selector).find('#TimeTransactionDate')) : skyward.controls.getValue($('#TimeTransactionDate'));
            const districtID = selector != null ? $(selector).find('#DistrictID').val() : $('#DistrictID').val();

            skyward.window.loadContent("full", "TimeTracking", "Employee", "ChangeStatus", districtID, { timetransactiondate: timeTransactionDate ? skyward.time.formatServerDate(timeTransactionDate, false) : null });
        }

        var createNewPopup = function (data) {
            return $.ajax(
            {
                url: skyward.global.virtualDir + "TimeTracking/Employee/ShowTimeTransactions" + '?renderType=contentOnly',
                data: data,
                type: 'POST',
                dataType: 'HTML'
            });
        };

        var show = function (event, selector)
        {
            var dataPromise = skyward.ajax.getAllInputElements(selector);
            var showTimeTransactions = dataPromise.then(data => createNewPopup(data));

            var saveButton = { text: "Save", click: saveData, icon: "Save" };

            dialog = skyward.modalLayer.showDialog("Time Transactions", showTimeTransactions, [{ text: "Close", icon: "Close" }, saveButton],
            {
                allowNoButtons: true,
                draggable: true,
                id: 'TimeTransactionsPopupModal'
            });

            function saveData()
            {
                skyward.ajax.getAllInputElements(selector).then(postedData =>
                {
                    var container = $(selector).find("#changeStatusTimeTransactionContent");
                    postedData['preSaveWarningHash'] = container.data('preSaveWarningHash') || "";
                    var promise = $.ajax(
                        {
                            url: skyward.global.virtualDir + "TimeTracking/Employee/SaveTimeTransactions",
                            type: "post",
                            dataType: "json",
                            data: postedData
                        });

                    promise.done(function (promiseData)
                    {
                        if (!promiseData.success)
                        {
                            skyward.validation.displayValidationMessages(promiseData, container, $(selector).find("#lblTimeTransactionsErrorMessage"));
                            postedData['preSaveWarningHash'] = promiseData.preSaveWarningHash;
                        }
                        else
                        {
                            reloadPage(selector);
                        }
                    });
                });
            }
        };

        var appendTimeTransactionRow = function (selector)
        {
            var element = $(selector).find(".button.changeStatusAddTimeTransaction");
            if (!skyward.buttonManager.isElementDisabled(element))
            {
                skyward.buttonManager.setClass(".button.changeStatusAddTimeTransaction");

                var pendingPostData = skyward.ajax.getAllInputElements(selector);
                pendingPostData.then((postData) =>
                {
                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + "TimeTracking/Employee/AppendTimeTransactionRow",
                            data: postData,
                            type: 'POST',
                            dataType: 'json',
                            success: function (successData)
                            {
                                $.when(skyward.global.processViewPartHtml(successData.Content)).then(function (html) {
                                    var browseTable = $(selector).find("#ChangeStatusTimeTransactionsEdit");
                                    var browseBody = browseTable.find(".unlockedBrowseTableBody");
                                    if (skyward.global.mobileAccess)
                                    {
                                        var content = skyward.browse.prepMobileBrowseData($(html)[0].outerHTML);
                                        var contentItems = Array.isArray(content) ? content : [content];
                                        contentItems.push(html[1]);
                                        browseBody.append(contentItems);
                                        skyward.browse.applyMobileLockedColumn(browseTable, browseTable.find('.browseBody'), browseBody);
                                    }
                                    else
                                    {
                                        browseBody.append(html);
                                    }
                                    skyward.window.notifyDOMLoad(successData.Id);
                                    dialog.animateModalContents();
                                    skyward.buttonManager.setClickInProgress(false)
                                });
                            }
                        });
                })
            }
        };

        var removerow = function ()
        {
            var data = $(this).data();
            $("#" + data.formname).remove();
            dialog.animateModalContents();
        };

        var events =
        {
            'removerow': removerow,
            "selectjob": selectjob
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('timetrackingchangestatus', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);